import { render } from "./ylyDeleteVideoTool.vue?vue&type=template&id=23961265&scoped=true"
import script from "./ylyDeleteVideoTool.vue?vue&type=script&lang=js"
export * from "./ylyDeleteVideoTool.vue?vue&type=script&lang=js"

import "./ylyDeleteVideoTool.vue?vue&type=style&index=0&id=23961265&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23961265"]])

export default __exports__